<script lang="ts" setup>
  import { computed } from "vue";

  const props = defineProps({
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
  });

  const value = defineModel();
  const dateFrom = defineModel("dateFrom");
  const dateTo = defineModel("dateTo");

  // Im readonly-Modus (z. B. WBB-Bogen) leere Felder ausblenden statt einen
  // Bindestrich zu zeigen – dort liegen keine dokumentierten Mengen vor.
  const showCount = computed(() => !props.readonly || value.value != null);
  const showFrom = computed(() => !props.readonly || !!dateFrom.value);
  const showTo = computed(() => !props.readonly || !!dateTo.value);
  const showRange = computed(() => showFrom.value || showTo.value);
</script>

<template>
  <div class="score-item-quantity" v-bind:class="{'score-item-quantity--extra-top-space': !!label}">
    <label class="score-item-quantity__label" v-if="label">{{label}}</label>

    <div class="score-item-quantity__field" v-if="showCount">
      <label class="score-item-quantity__field-label">Anzahl</label>
      <div class="score-item-quantity__value-readonly" v-if="readonly">
        {{ value }}
      </div>
      <input
        v-else
        type="number"
        min="0"
        step="1"
        class="score-item-quantity__input"
        v-model.number="value"
      />
    </div>

    <div class="score-item-quantity__range" v-if="showRange">
      <div class="score-item-quantity__field" v-if="showFrom">
        <label class="score-item-quantity__field-label">von<span v-if="!readonly">&nbsp;*</span></label>
        <div class="score-item-quantity__value-readonly" v-if="readonly">
          {{ dateFrom }}
        </div>
        <input
          v-else
          type="date"
          class="score-item-quantity__date"
          v-model="dateFrom"
        />
      </div>

      <div class="score-item-quantity__field" v-if="showTo">
        <label class="score-item-quantity__field-label">bis</label>
        <div class="score-item-quantity__value-readonly" v-if="readonly">
          {{ dateTo }}
        </div>
        <input
          v-else
          type="date"
          class="score-item-quantity__date"
          v-model="dateTo"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.score-item-quantity {
  margin: 7px 0;
}

.score-item-quantity--extra-top-space {
  margin-top: 15px;
}

.score-item-quantity__field {
  display: inline-block;
  margin-right: 16px;
  vertical-align: top;
}

.score-item-quantity__range {
  margin-top: 10px;
}

.score-item-quantity__input {
  max-width: 160px;
}

.score-item-quantity__date {
  max-width: 180px;
}

.score-item-quantity__label {
  font-size: 12px;
  margin-bottom: 2px;
  padding-left: 2px;
  display: block;
}

.score-item-quantity__field-label {
  font-size: 12px;
  margin-bottom: 2px;
  padding-left: 2px;
  display: block;
}

.score-item-quantity__value-readonly {
  border: 1px solid black;
  background-color: white;
  padding: 10px;
  display: inline-block;
  min-width: 80px;
}
</style>
